export const CART_ADD_ITEM: "CART_ADD_ITEM" = "CART_ADD_ITEM";
export const CART_MINUS_ITEM: "CART_MINUS_ITEM" = "CART_MINUS_ITEM";
export const CART_REMOVE_ITEM: "CART_REMOVE_ITEM" = "CART_REMOVE_ITEM";
export const CART_CLEAR_ITEMS: "CART_CLEAR_ITEMS" = "CART_CLEAR_ITEMS";
